module.exports = __webpack_public_path__ + "static/pic02-b9e518c6c07630bc425fb67dd4c130dd.jpg";